import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { stringify } from 'qs'
import { CmsFaqCategory } from 'types/cms/collection-types'
import { BiLingualValue } from 'types/common'

/**
 * Get the faq categories from the CMS
 * @param {string | BiLingualValue<string[]>} slugs
 * @param {Language} locale
 * @returns {Promise<CmsFaqCategory[]>}
 */
const getFaqCategories = async (
  slugs: string | string[] | BiLingualValue<string[]>,
  locale: Language = Language.DUTCH
): Promise<CmsFaqCategory[]> => {
  try {
    const query = stringify({
      filters: {
        slug: typeof slugs === 'string' ? [slugs] : Array.isArray(slugs) ? slugs : slugs[locale]
      },
      locale,
      status: 'published'
    })

    const { data } = await axios.get<CMSApiResponseBody<CmsFaqCategory[]>>(`${process.env.CMS_API_URL}/faq-categories?${query}`)

    return data.data
  } catch (_) {
    return []
  }
}

export default getFaqCategories
